<div class="ap-display-block ap-margin-2">
    <ap-skeleton data-testid="loading">
        <div class="ap-margin-bottom-6">
            <ap-paragraph-skeleton [rows]="1"></ap-paragraph-skeleton>
            <ap-paragraph-skeleton [rows]="1"></ap-paragraph-skeleton>
        </div>

        <div class="ap-margin-bottom-4 ap-grid ap-grid-cols-12">
            <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
            <div class="ap-col-span-6"></div>
            <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
            <div class="ap-col-span-6"></div>
            <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
            <div class="ap-col-span-6"></div>
        </div>

        <div class="ap-margin-bottom-4 ap-grid ap-grid-cols-12">
            <div class="ap-col-span-6"></div>
            <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
            <div class="ap-col-span-6"></div>
            <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
            <div class="ap-col-span-6"></div>
            <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
        </div>

        <div class="ap-margin-bottom-4 ap-grid ap-grid-cols-12">
            <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
            <div class="ap-col-span-6"></div>
            <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
            <div class="ap-col-span-6"></div>
            <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
            <div class="ap-col-span-6"></div>
        </div>

        <div class="ap-margin-bottom-4 ap-grid ap-grid-cols-12">
            <div class="ap-col-span-6"></div>
            <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
            <div class="ap-col-span-6"></div>
            <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
            <div class="ap-col-span-6"></div>
            <ap-paragraph-skeleton class="ap-col-span-6" [rows]="1"></ap-paragraph-skeleton>
        </div>
    </ap-skeleton>
    <ap-paragraph-skeleton [rows]="1"></ap-paragraph-skeleton>
    <ap-paragraph-skeleton [rows]="1"></ap-paragraph-skeleton>
</div>
